import { X } from "lucide-react";
import { useState } from "react";
import FilterCard from "../../shared/FilterCard";
import Calendar from "react-calendar";

const AuditFilter = ({
  closeFilters,
  handleApplyFilter,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
}) => {
  const [activeTab, setActiveTab] = useState("From Date");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div
      onClick={(e) => {
        closeFilters();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[750px] h-[550px] rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeFilters}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] right-[20px] flex items-center gap-[10px]">
          <button
            onClick={() => {}}
            className="h-[35px] bg-[#FFFFFF] border border-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-[#000000]"
          >
            Clear Filters
          </button>
          <button
            onClick={handleApplyFilter}
            className="h-[35px] bg-[#000000] rounded-[30px] px-[15px] text-[15px] font-bold text-white"
          >
            Apply Filters
          </button>
        </div>
        <div className="w-full">
          <p className="text-[#000000] text-[20px] font-medium">Filters</p>
          <p className="w-[90%] text-[#5C5C5C] text-[14px] font-normal">
            Refine your view by selecting specific criteria. Apply filters to
            quickly find the loans you need. You can reset or adjust filters
            anytime.
          </p>
          <div className="h-[400px] w-full flex">
            <div className="w-[30%] p-[10px] bg-[#F8F8F8] h-full overflow-y-auto">
              <div className="flex items-center justify-between">
                <p className="text-[#000000] text-[14px] font-medium">
                  Filters
                </p>
                <span className="bg-[#FFDEDE] text-[#000000] text-[12px] font-normal h-[30px] rounded-[30px] px-[10px] flex items-center justify-center">
                  0 applied
                </span>
              </div>
              <div className="flex flex-col my-[20px] gap-[20px]">
                <FilterCard
                  label="From Date"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
                <FilterCard
                  label="To Date"
                  activeTab={activeTab}
                  activeBorderColor="#FFA5A5"
                  handleTabClick={handleTabClick}
                />
              </div>
            </div>

            <div className="w-[70%] p-[10px] bg-[#FBF5F5] h-full">
              <p className="text-[#000000] text-[14px] font-medium">
                {activeTab}
              </p>
              <p className="text-[#222222] text-[14px] font-normal">
                Select your {activeTab?.toLowerCase()} filter
              </p>
              {activeTab === "From Date" && (
                <div className="w-full flex items-start justify-center mt-[10px] p-[10px] h-full overflow-y-auto">
                  <Calendar
                    onChange={(val) => setFromDate(val)}
                    value={fromDate ? new Date(fromDate) : null}
                    maxDate={toDate ? new Date(toDate) : new Date()}
                  />
                </div>
              )}
              {activeTab === "To Date" && (
                <div className="w-full flex items-start justify-center mt-[10px] p-[10px] h-full overflow-y-auto">
                  <Calendar
                    onChange={(val) => setToDate(val)}
                    value={toDate ? new Date(toDate) : null}
                    minDate={fromDate ? new Date(fromDate) : null}
                    maxDate={new Date()}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditFilter;
